import { Paystub } from '@models/payroll/paystub.model';
import { Component } from '@angular/core';
import { AuthService, NotifyService, UrlHelperService } from '@app/services';
import { Paginator } from '@app/classes';
import { IndexView } from '@common/views';
import { environment } from '@env/environment';
import { saveAs } from 'file-saver';

@Component({
    templateUrl: './paystub-index.template.html',
    styleUrls: ['./paystub-index.style.scss'],
})
export class PaystubIndexView extends IndexView {
    isLoading = true;

    constructor(
        private urlHelper: UrlHelperService,
        private auth: AuthService,
        private notify: NotifyService
    ) {
        super();
        this.paginator = new Paginator(Paystub.param('employee', this.auth.user.id), { shouldAutoLoadData: true });
        this.paginator.onLoading((loading: boolean) => (this.isLoading = loading));
    }

    onCreate(): void {}

    getUrl(paystub: Paystub): string {
        return (
            `${environment.api}/${Paystub.version}/` +
            Paystub.resource.replace(':employee', `${this.auth.user.id}`).concat(`/${paystub.id}`)
        );
    }

    onDownload(paystub: Paystub): void {
        const path =
            `${environment.api}/${Paystub.version}/` +
            Paystub.resource.replace(':employee', `${this.auth.user.id}`).concat(`/${paystub.id}`);

        this.urlHelper.getBlob(path).subscribe((data) => {
            if (!data) {
                this.notify.error('No Paystub file available');

                return;
            }

            saveAs(data, `paystub-${paystub.chequeDate}.pdf`);
        });
    }
}
